import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import enUSLang from './en_US.json'
import frFRLang from './fr_FR.json'
import deDELang from './de_DE.json'
import esESLang from './es_ES.json'
import jsJPLang from './ja_JP.json'
import heILLang from './he_IL.json'

export const LANGUAGE_FALLBACK = 'en'

i18next
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enUSLang },
      fr: { translation: frFRLang },
      de: { translation: deDELang },
      es: { translation: esESLang },
      jp: { translation: jsJPLang },
      he: { translation: heILLang }
    },
    fallbackLng: LANGUAGE_FALLBACK,

    interpolation: { escapeValue: false }
  })

export { default as i18n } from 'i18next'
